<template>
  <div class="homeBox">
    <div class="building">
      <el-image :src="imgUrl"></el-image>
    </div>
    <div class="contentBox">
      <div>HELLO!</div>
      <div>
        <el-image style="width:100%" :src="imgJfy"></el-image>
      </div>
      <div class="formDiv">
        <el-form :model="form">
          <el-form-item class="elInput">
            <el-input v-model="form.username" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item class="elInput">
            <el-input v-model="form.password" type="password" placeholder="请输入密码"></el-input>
          </el-form-item>
          <!-- <el-form-item> -->
          <div class="mind">
            <el-checkbox v-model="checked">记住密码</el-checkbox>
          </div>
          <!-- </el-form-item> -->
          <el-form-item class="codeCss">
            <el-input v-model="form.captcha" placeholder="请输入验证码"></el-input>
            <el-button round @click="codeFn">获取验证码</el-button>
            <div>
              <img class="imageText" :src="imageText" alt @click="codeFn" />
            </div>
            <!-- <div>验证码</div> -->
          </el-form-item>
          <!-- <el-form-item>
            <el-input v-model="form.name" placeholder="请输入验证码"></el-input>
            <div>验证码</div>
          </el-form-item>-->
          <el-form-item class="loginBtn">
            <el-button round @click="loginFn">登陆</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
// import {codeGet,signPost,Login} from '@/request/login.js'
import {distributorTwoLogin,getCaptcha} from '@/request/index.js'
export default {
  data() {
    return {
      currindex:'1',
      form: {
        captcha: "",
        password:"",
        username:"",
        key:"",
      },
      imgUrl: require("../assets/login.png"),
      imgJfy: require("../assets/jfy.png"),
      checked: "",
      imageText:""
    };
  },
  created(){
    this.codeFn()
    if(localStorage.getItem('password2')){
      const Base64 = require("js-base64").Base64
      this.form.username = localStorage.getItem('username2')
      this.form.password = Base64.decode(localStorage.getItem('password2')) 
    }
  },
  methods: {
    // // 获取验证码接口
    codeFn() {
      getCaptcha().then(res => {
        if (res) {
          this.form.key = res.data.url.key;
          this.imageText = res.data.url.img;
        }
      });
    },
    loginFn() {
      distributorTwoLogin(this.form).then(res=>{
          if(res.data.status=='ok'){
            if(res.data.result.permission.length==0){
              this.$message.error('该账号无权限')
              return false
            }
            window.sessionStorage.setItem("menue", JSON.stringify(res.data.result.permission));
            this.$message.success('登陆成功');
            window.sessionStorage.setItem("Token", res.data.result.token);
            window.sessionStorage.setItem('path',this.$route.path)
            if(this.checked){
              const Base64 = require("js-base64").Base64
              let password = Base64.encode(this.form.password); // base64加密
              localStorage.setItem("username2", this.form.username);
              localStorage.setItem("password2", password);
            }else{
              localStorage.removeItem("username2");
              localStorage.removeItem("password2");
            } 
            this.$router.push("/dis");
          }else{
            this.$message.error(res.data.msg);
          }
      })
    }
  }
};
</script>

<style lang='less' scoped>
.tab{
  width: 28.6rem;
  height: 6rem;
  background: #ffffff;
  position: absolute;
  right: 6rem;
  top: 4rem;
  border-radius: 3rem;
  display: flex;
  div{
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666666;
    font-size: 1.6rem;
    cursor: pointer;
  }
  .current{
    border-radius:3rem ;
    background: #246DEB;
    color: #ffffff;
  }
}
.homeBox {
  width: 100%;
  height: 100%;
  position: relative;
  .building {
    width: 100%;
    height: 100%;
    overflow: auto;
    /deep/.el-image {
      width: 100%;
      height: 100%;
    }
  }
  .contentBox {
    width: 640px;
    height: 645px;
    position: absolute;
    top: 100px;
    left: 143px;
    > div:nth-child(1) {
      font-family: "Roboto";
      font-style: normal;
      font-weight: 400;
      font-size: 96px;
      line-height: 112px;
      /* identical to box height */

      color: #666666;
    }
    .formDiv {
      margin-top: 50px;
      .elInput {
        height: 60px;
        margin-bottom: 20px;
        /deep/.el-input {
          width: 550px;
          height: 60px;
          line-height: 60px;
          background: #f7f7fa;
          border-radius: 30px;
        }
        /deep/.el-input__inner {
          width: 550px;
          height: 60px;
          line-height: 60px;
          background: #f7f7fa;
          border-radius: 30px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 22px;

          color: #666666;
        }
      }
    }
    .codeCss {
      width: 100%;
      /deep/.el-form-item__content {
        display: flex;
      }
      /deep/.el-input {
        width: 350px;
        height: 60px;
        margin-right: 20px;
      }
      /deep/.el-input__inner {
        width: 350px;
        height: 60px;
        background: #f7f7fa;
        border-radius: 30px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #000000;
      }
      /deep/.el-button {
        background: #ffffff;
        border: 1px solid #487cff;
        border-radius: 30px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;

        color: #487cff;
      }
    }
    .loginBtn {
      /deep/.el-button {
        width: 200px;
        height: 60px;
        background: #487cff;
        border-radius: 30px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 28px;
        /* identical to box height */
        border: none;
        color: #ffffff;
      }
    }
    .mind {
      margin-bottom: 40px;
      margin-left: 50px;
      //   /deep/.el-checkbox__inner {
      //     width: 16px;
      //     height: 16px;
      //   }
      //   /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
      //     font-family: ".PingFang SC";
      //     font-style: normal;
      //     font-weight: 400;
      //     font-size: 16px;
      //     color: #333333;
      //   }
    }
  }
}
.imageText {
  width: 162px;
  height: 60px;
  margin-left: 40px;
  // border: none;
}
.el-button {
  height: 60px;
}
</style>